import { render, staticRenderFns } from "./ClinicVideos.vue?vue&type=template&id=308dd62e&"
import script from "./ClinicVideos.vue?vue&type=script&lang=js&"
export * from "./ClinicVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports